import * as React from "react";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

export const bugsnagClient = Bugsnag.start({
  apiKey: "f0546c7f9b254d669b7fa43178bd1e04",
  appVersion: `${process.env.WIB_RELEASE_BRANCH} ${process.env.WIB_RELEASE_VERSION}`,
  plugins: [new BugsnagPluginReact()]
});

export const BugsnagErrorBoundary = bugsnagClient
  .getPlugin("react")
  .createErrorBoundary(React);
